import { render, staticRenderFns } from "./allCompanies.vue?vue&type=template&id=b657ef3e&"
import script from "./allCompanies.vue?vue&type=script&lang=js&"
export * from "./allCompanies.vue?vue&type=script&lang=js&"
import style0 from "./allCompanies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports